import { ActionContext, ActionTree } from "vuex";
import { GetterTree } from "vuex";
import { NavigationsQM, NavigationItem } from "@/model/NavigationItem";

const initialItemState: NavigationItem[] = [{
  num: 0,
  screenId: '',
  screenCd: '',
  screenNm: '',
  page: '',
  status: '',
  isNavigation: 0,
}];

const initialState: NavigationsQM = {
  items: initialItemState,
};

const actions: ActionTree<NavigationsQM, any> = {
  setState(
    { commit }: ActionContext<NavigationsQM, any>,
    payload: NavigationsQM
  ): void {
    commit("setState", payload);
  },
  clearState({ commit }: ActionContext<NavigationsQM, any>): void {
    commit("clearState");
  }
};

const mutations = {
  setState(state: NavigationsQM, payload: NavigationsQM) {
    Object.assign(state, payload);
  },
  clearState(state: NavigationsQM) {
    Object.assign(state, { ...initialState });
  }
};

const getters: GetterTree<NavigationsQM, any> = {
  currentState(state: NavigationsQM): any {
    return state;
  },
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
